/**
 * Versão do app (espelha `version` do package.json), injetada em build pelo Vite.
 * @see vite.config.ts — `define.__APP_VERSION__`
 */
export const APP_BUILD_VERSION: string = __APP_VERSION__;
